// TEST-INFRA (NICHT in beta committen): env-gated Variante von src/utils/firebase.js,
// die bei REACT_APP_USE_EMULATOR=true gegen die lokalen Emulatoren (demo-gastronaut)
// verbindet. Wird auf der Devbox über die echte firebase.js gelegt und danach
// wiederhergestellt. Firebase v8.
import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/analytics';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/storage';
import 'firebase/functions';
import 'firebase/messaging';

const USE_EMU = process.env.REACT_APP_USE_EMULATOR === 'true';

const prodConfig = {
  apiKey: process.env?.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env?.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env?.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env?.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env?.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env?.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env?.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env?.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Emulator: projectId MUSS demo-gastronaut sein (so wurde geseedet); Keys sind Dummies.
const emuConfig = {
  apiKey: 'demo-emulator-key',
  authDomain: 'demo-gastronaut.firebaseapp.com',
  databaseURL: 'http://127.0.0.1:9000/?ns=demo-gastronaut',
  projectId: 'demo-gastronaut',
  storageBucket: 'demo-gastronaut.appspot.com',
  messagingSenderId: '000000000000',
  appId: '1:000000000000:web:demoemulator',
};

const config = USE_EMU ? emuConfig : prodConfig;

if (!firebase.apps || !firebase.apps.length) {
  firebase.initializeApp(config);
}

if (USE_EMU) {
  const H = '127.0.0.1';
  firebase.firestore().useEmulator(H, 8080);
  firebase.auth().useEmulator(`http://${H}:9099`, { disableWarnings: true });
  firebase.database().useEmulator(H, 9000);
  firebase.storage().useEmulator(H, 9199);
  firebase.app().functions('europe-west3').useEmulator(H, 5001);
  // eslint-disable-next-line no-console
  console.log('[firebase] EMULATOR-Modus aktiv (demo-gastronaut).');
}

// Analytics im Emulator überspringen (kein measurementId, würde warnen/werfen).
if (!USE_EMU) {
  try {
    firebase.analytics();
  } catch (e) {}
}

export const db = firebase.firestore();
export const rtDB = firebase.database();
export const FieldValue = firebase.firestore.FieldValue;
export const storageRef = firebase.storage().ref();
export const functions = firebase.app().functions('europe-west3');

export default firebase;
